angular.module('gym.users').controller('UsersCtrl', ["$scope", "$rootScope", "$window", "$state", "$modal", "ReactModal", "$http", "flash", "GTMService", "EmploymentService", "AdminUserService", "MessageService", function($scope, $rootScope, $window, $state, $modal, ReactModal, $http, flash, GTMService, EmploymentService, AdminUserService, MessageService) {
  var openManageMfaModal, toggleAccess;
  GTMService.trackPage('Users');
  $scope.gym = $rootScope.gym;
  $scope.adminHasPermission = AdminUserService.has;
  $scope.permissions = EmploymentService.get().permissions;
  if (!$scope.permissions.manage_users) {
    $state.go('gym.dashboard');
  }
  openManageMfaModal = function(user, employmentId) {
    return ReactModal.open({
      component: 'ManageMfaModal',
      props: {
        mode: 'manage_user_mfa',
        employmentId: employmentId,
        user: user
      }
    });
  };
  $scope.manageMfa = function(user, employmentId) {
    if (user.id === window.currentUser.id) {
      return $state.go('gym.profile', {
        tab: 'mfa'
      });
    } else {
      return openManageMfaModal(user, employmentId);
    }
  };
  $scope.manageMfaPolicy = function() {
    return $modal.open({
      template: require('templates/gyms/users/manage_mfa_policy_modal.html.slim'),
      controller: 'ManageMfaPolicyModalController'
    });
  };
  $scope.resetPassword = function(name, id, email) {
    return MessageService.message({
      title: `Reset password for ${name}`,
      message: [`This will reset the password for ${name}. To regain access to Clubworx, they will need to complete the \"Forgot Password\" process.`, "We recommend resetting a password if you believe a user may be using an insecure or compromised password."],
      confirmButtonText: 'Reset Password',
      cancelButtonText: 'Cancel'
    }).then(function() {
      var url;
      url = `/gyms/${$scope.gym.id}/users/${id}/reset_password`;
      return $http.put(url).then(function() {
        return flash.success = `Password reset successfully. A notification has been sent to ${email} with further instructions.`;
      }, function() {
        return flash.error = "Request could not be completed. Please try again";
      });
    });
  };
  toggleAccess = function(id, enabled) {
    var params, url;
    params = {
      employment: {
        disabled: !enabled
      }
    };
    url = `/gyms/${$scope.gym.id}/users/${id}`;
    return $http.put(url, params).then(function() {
      return $window.location.reload();
    }, function() {
      return flash.error = "Request could not be completed. Please try again";
    });
  };
  $scope.enableAccess = function(name, id) {
    if ($window.confirm(`Reinstate Clubworx login access for ${name}?`)) {
      return toggleAccess(id, true);
    }
  };
  $scope.blockAccess = function(name, id) {
    return MessageService.message({
      title: `Block access for ${name}`,
      message: ["Blocking access for a user will stop them from signing in to Clubworx, but you will still be able to attach them to tasks, or to events as an instructor.", "You can re-enable access again in future if needed.", "Continue?"],
      confirmButtonText: 'Block Access',
      cancelButtonText: 'Cancel'
    }).then(function() {
      return toggleAccess(id, false);
    });
  };
  $scope.confirmNewInvite = function(invitationId, userName) {
    return MessageService.message({
      title: "Replace expired invitation",
      message: [`This invitation for ${userName} has expired, as it was not accepted within 7 days of being sent.`, 'To generate a new invitation for this user, click the "Send new Invite" button below.'],
      confirmButtonText: 'Send new Invite',
      cancelButtonText: 'Cancel'
    }).then(function() {
      var url;
      url = `/gyms/${$scope.gym.id}/invitations/${invitationId}/resend`;
      return $http.post(url).then(function() {
        $window.location.reload();
        return flash.success = "Invitation re-sent";
      }, function() {
        return flash.error = "Request could not be completed. Please try again";
      });
    });
  };
  return $scope.deleteUser = function(user, employmentId, allUsers) {
    return ReactModal.open({
      component: 'DeleteUserModal',
      props: {
        user: user,
        employmentId: employmentId,
        allUsers: allUsers
      }
    }).then(function() {
      return $window.location.reload();
    });
  };
}]);
